import { api } from 'pages/APIs';
import type { dynamicObj } from 'src/pages/assets';
import { isUndefinedOrNull } from 'src/utils/general';
import AbstractApiService from 'src/services/abstractApiService';

export default class TaskApiService extends AbstractApiService {
  public constructor({}) {
    super({});
  }

  public async getTasks(params: dynamicObj): Promise<any> {
    return this.getTaskList(params);
  }
  public async getTaskList(params: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(params);
    return super.get(api.api_task + '?' + querystring, {});
  }

  public async getTotalTaskCount(params: dynamicObj): Promise<any> {
    const querystring = this.encodeQueryData(params);
    return super.get(api.api_total_tasks_count + '?' + querystring, {});
  }

  public async getTaskById(id: string, use_cache = true): Promise<any> {
    let cache = use_cache.toString();
    cache = cache.charAt(0).toUpperCase() + cache.slice(1);
    cache = `?cache=${cache}`;
    return super.get(api.api_task + '/by-id/' + id + cache, {});
  }

  public async createTask(data: dynamicObj): Promise<any> {
    const api_data: any = {};
    for (const [key, value] of Object.entries(data)) {
      api_data[key] = String(value);
    }
    return super.post(api.api_task, api_data);
  }

  public async deleteTask(id: string): Promise<any> {
    return super.delete(api.api_task + '/by-id/' + id, {});
  }
  public async bulkDeleteTasks(task_ids: string[]): Promise<any> {
    const form = new FormData();
    form.append('task_ids', task_ids.join(','));
    return super.delete(api.api_task, form);
  }
  public async updateTask(id: string, data: dynamicObj): Promise<any> {
    const api_data: any = {};
    for (const [key, value] of Object.entries(data)) {
      api_data[key] = String(value);
    }

    return super.patch(api.api_task + '/by-id/' + id, api_data);
  }
  public async bulkUpdateStatusTasks(
    task_ids: dynamicObj,
    status: string,
  ): Promise<any> {
    const form = new FormData();
    form.append('task_ids', task_ids.join(','));
    form.append('status', status);
    return super.patch(api.api_task + '/status', form);
  }

  public async editTask(id: string, data: dynamicObj): Promise<any> {
    const api_data: any = {};
    for (const [key, value] of Object.entries(data)) {
      if (isUndefinedOrNull(value)) {
        continue;
      }
      api_data[key] = String(value);
      api_data['cache'] = false;
    }
    return super.put(api.api_task + '/by-id/' + id, api_data);
  }
}
